export const localMultiplayerParams = new URLSearchParams(window.location.search);
// The production build cannot select the local transport through a URL flag.
export const localMultiplayer = typeof __LOCAL_MULTIPLAYER__ !== 'undefined' && __LOCAL_MULTIPLAYER__
	&& ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)
	&& localMultiplayerParams.get('multiplayerLocal') === '1';
